"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filter = void 0;
var filter = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1403 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z"
    }
  }]
};
exports.filter = filter;